import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../store/actions/index';

class MyInfoCallback extends Component {
    componentDidMount() {
        if (localStorage.getItem('sessionId') === null) {
            //if page is refreshed with query string, dont call myInfo just go to landing page
            this.props.onUpdateSource(false);
            this.props.onChangeStage(1);
        } else {
            const search = this.props.location.search;
            const params = new URLSearchParams(search);
            const payload = {
                authCode: params.get('code'),
                error: params.get('error'),
                state: params.get('state'),
                includeCpf: localStorage.getItem('includeCpf'),
                codeVerifier: localStorage.getItem('codeVerifier'),
            };
            //this.props.history.push(localStorage.getItem('sessionId'));
            this.props.history.push(localStorage.getItem('sessionId'), { fromMyInfo: true });
            if (payload.error) {
                // Goto Manual APplication with error
                this.props.onUpdateSource(false);
                this.props.onChangeStage(4);
                this.props.onMyInfoFailed(payload.error);
            } else {
                setTimeout(() => {
                    this.props.onGetMyInfoData(payload);
                }, 100);
            }
        }
    }

    render() {
        return null;
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGetMyInfoData: payload => dispatch(actions.onGetMyInfoDataStart(payload)),
        onUpdateSource: flag => dispatch(actions.updateSource(flag)),
        onChangeStage: stage => dispatch(actions.stageUpdate(stage)),
        onMyInfoFailed: error => dispatch(actions.onGetMyInfoDataFailed(error)),
    };
};

export default withRouter(connect(null, mapDispatchToProps)(MyInfoCallback));
